import type { HarnessWireApi } from './types';

export interface WireApiOption {
  value: HarnessWireApi;
  label: string;
}

/** The only two wire formats an OpenAI-type gateway can be declared to speak (spec 204). */
export const WIRE_API_OPTIONS: WireApiOption[] = [
  { value: 'responses', label: 'Responses API' },
  { value: 'chat', label: 'Chat Completions' },
];

/** Matches the service's own default, so taking no action changes nothing. */
export const DEFAULT_WIRE_API: HarnessWireApi = 'responses';

export function isHarnessWireApi(value: unknown): value is HarnessWireApi {
  return WIRE_API_OPTIONS.some((option) => option.value === value);
}

/** Saved value, or the default when none was stored (spec FR-007). */
export function wireApiOrDefault(value: unknown): HarnessWireApi {
  return isHarnessWireApi(value) ? value : DEFAULT_WIRE_API;
}
